// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"PackageAvailabilityNotifyButton_buttonWrapper__jlPxa","icon":"PackageAvailabilityNotifyButton_icon__OeTP3"};